import React, { useEffect } from 'react'
import { observer } from 'mobx-react'

import moment from 'moment'
import Panel from '../../../UniformComponents/Panel'
import Button from '../../../UniformComponents/Button'
import Badge from '../../../UniformComponents/Badge'
import DataTable from '../../DataTable'

const columns = [
    {
        name: 'Feature',
        key: 'label',
        cellClass: 'ff-table__feature',
        dataTransform: (label, row) => (
            <div className="ff-table__feature">
                <div className="ff-table__feature-label">{label}</div>
                <div className="ff-table__feature-name">
                    {row.name}
                    {' · id '}
                    {row.id}
                </div>
            </div>
        ),
    },
    {
        name: 'Scope',
        key: 'scope',
    },
    {
        name: 'State',
        key: 'active',
        dataTransform: (active) => (
            <Badge
                cssClass="ff-status"
                icon="fa-solid fa-circle"
                label={active ? 'Live' : 'Suspended'}
                isRounded
                type={active ? 'success' : 'error'}
            />
        ),
    },
    {
        name: 'Who can reach it',
        key: 'summary',
        cellClass: 'ff-table__summary',
        dataTransform: (summary, row) => (
            <div className="ff-table__summary">
                <div>{summary}</div>
                {row.issue && (
                    <span className="ff-pill ff-pill--danger">
                        <i className="fal fa-triangle-exclamation" />
                        {row.issue}
                    </span>
                )}
            </div>
        ),
    },
    {
        name: 'Last edited',
        key: 'lastUpdated',
        cellClass: 'ff-table__updated',
        dataTransform: (lastUpdated, row) => (
            <div className="ff-table__summary">
                <div>
                    {moment(lastUpdated).format('D MMMM YYYY')}
                    {' · '}
                    {row.userName}
                </div>
            </div>
        ),
    },
]

const Search = ({ store }) => {
    const rows = store.filteredRows

    useEffect(() => {
        store.loadFlags()

        return () => {
            store.flags = []
        }
    }, [])

    return (
        <div className="ff-index">
            <div className="ff-index__header">
                <div>
                    <h1>Feature flags</h1>
                    <p className="ff-index__intro">Who can reach each feature on this server. Changes here take effect without a release.</p>
                    <p className="ff-index__note">Features can be gated on role, role addons, industry, product type, survey type and purchase tags.</p>
                </div>
                <div className="ff-index__actions">
                    <Button
                        cssClass="regular"
                        label="New feature flag"
                        variant="primary"
                        icon="fal fa-plus"
                        onClick={store.newFlag}
                    />
                </div>
            </div>

            <Panel
                style={{ padding: '16px 0px' }}
            >
                <div className="ff-filter-bar">
                    <div className="ff-search">
                        <i className="fal fa-magnifying-glass" />
                        <input
                            value={store.query}
                            onChange={store.setQuery}
                            placeholder="Search feature name"
                        />
                    </div>
                    <div className="ff-filter-group">
                        <span className="ff-eyebrow">Scope</span>
                        {['all', 'global', 'survey'].map((value) => (
                            <Badge
                                rounded
                                label={value === 'all' ? 'All' : value}
                                onClick={() => store.setScopeFilter(value)}
                                cssClass={`ff-scope-pill ${store.scopeFilter === value ? 'is-selected' : ''}`}
                            />
                        ))}
                    </div>
                    <div className="ff-filter-group">
                        <span className="ff-eyebrow">State</span>
                        {['all', 'live', 'suspended'].map((value) => (
                            <Badge
                                rounded
                                label={value === 'all' ? 'All' : value}
                                onClick={() => store.setStateFilter(value)}
                                cssClass={`ff-scope-pill ${store.stateFilter === value ? 'is-selected' : ''}`}
                            />
                        ))}
                    </div>
                </div>

                <DataTable
                    inMemory
                    dataSet={rows}
                    columns={columns}
                    rowId="id"
                    rowClick={(e, id) => store.openFlag(rows.find((row) => row.id === id))}
                    cssClass="ff-table"
                />
            </Panel>
        </div>
    )
}

export default observer(Search)
